import { ref } from "vue";
import { defineStore } from "pinia";

export const useOnboardingStore = defineStore("onboarding", () => {
  const isDashboardOnboardingSkipped = ref(true);
  const isAppsOnboardingSkipped = ref(true);
  const isP2POnboardingSkipped = ref(true);
  const isEarnOnboardingSkipped = ref(true);
  const isProfileOnboardingSkipped = ref(true);

  const getIsDashboardOnboardingSkipped = () => {
    return isDashboardOnboardingSkipped.value;
  };

  const getIsAppsOnboardingSkipped = () => {
    return isAppsOnboardingSkipped.value;
  };

  const getIsP2POnboardingSkipped = () => {
    return isP2POnboardingSkipped.value;
  };

  const getIsEarnOnboardingSkipped = () => {
    return isEarnOnboardingSkipped.value;
  };

  const getIsProfileOnboardingSkipped = () => {
    return isProfileOnboardingSkipped.value;
  };

  const setIsProfileOnboardingSkipped = (data) => {
    isProfileOnboardingSkipped.value = data;
  };
  const setIsAppsOnboardingSkipped = (data) => {
    isAppsOnboardingSkipped.value = data;
  };
  const setIsDashboardOnboardingSkipped = (data) => {
    isDashboardOnboardingSkipped.value = data;
  };
  const setIsP2POnboardingSkipped = (data) => {
    isP2POnboardingSkipped.value = data;
  };
  const setIsEarnOnboardingSkipped = (data) => {
    isEarnOnboardingSkipped.value = data;
  };
  return {
    getIsDashboardOnboardingSkipped,
    getIsAppsOnboardingSkipped,
    getIsP2POnboardingSkipped,
    getIsEarnOnboardingSkipped,
    getIsProfileOnboardingSkipped,
    setIsProfileOnboardingSkipped,
    setIsAppsOnboardingSkipped,
    setIsDashboardOnboardingSkipped,
    setIsP2POnboardingSkipped,
    setIsEarnOnboardingSkipped,
  };
});
